import Vue from 'vue'
import Vuex from 'vuex'
import * as api from '../api'
import lib from '../lib' //надо!
import i18n from '../i18n'

Vue.use(Vuex);
window.is_vue_log=false;

export const store = new Vuex.Store({

	state: {
    usedFilters: [],

    sets: {},
    setsTotal: 0,
    setsLoading: true,

    artists: {},
    artistsTotal: 0,
    artistsLoading: true,

		worksTotal: 0,
		works: {},
		wfilter: '',
    worksTotalOnMap: 0,

		worksRecently: {},
    worksFeatured: {},

    works_on_map: {},
    works_on_map_total: {},
    works_on_map_cluster: {},
    works_on_map_cluster_total: {},
    works_on_map_list: {},
    works_on_map_list_total: {},

    artistCollections: {},
    artistCollectionsWorks: [],

    galleryCollections: {},
    galleryCollectionsWorks: [],

		filters: {
			p: "1"
		},
		tags: {},
		modificators: {},//похоже на чильтры, но не фильтры
    dont_update_route:false,//не обновлять route, а только путь в строке адреса. Чтобы не уходили запросы для обновления компонент

    // фильтры
		arttypes:{},
		saletypes:{},
    countries: {},
    colors: {},
    filters_counts: {},
    genres: {},
    presets: {},
    sizes: {},
    styles: {},
    techniques: {},
    places: {},
    galleries: {},
    schools: {},
    materials: {},
    periods: {},
    prices: {},

    seo_title:'',
    seo_text:'',

    advanced: true,
		worksLoading: true,
		pushWorks: false,

    // см. themes/lib/consts.xsl const_langs_all
		langs: [
			{value:'RU', 'label':i18n.t('message.langRU')},
			{value:'UK', 'label':i18n.t('message.langUK')},
			{value:'EN', 'label':i18n.t('message.langEN')},
			{value:'DE', 'label':i18n.t('message.langDE')},
			{value:'ES', 'label':i18n.t('message.langES')},
			{value:'FR', 'label':i18n.t('message.langFR')},
			{value:'IT', 'label':i18n.t('message.langIT')},
			{value:'SL', 'label':i18n.t('message.langSL')},
			{value:'ZH', 'label':i18n.t('message.langZH')},
		],

		userId     : '',
		user_artist_id: 0,
    user_currency: 'usd',
    is_user_has_pro: false,
    is_user_has_payout: false,
    is_user_editor: false,

		is_scroll: false
	},

	actions: {
		getArtistCollections({commit,dispatch}, filter) {
		  if (window.is_vue_log) console.log('actions: '+'getArtistCollections');

			return new Promise((resolve, reject) => {
				var url = '/action/vue/artists/collections-list';

				api.get(url, filter).then(response => {
					commit('GET_ARTIST_COLLECTIONS',response.data);
					resolve();
				}).catch(e => {
					console.log(e);
					reject();
				})
			})
		},
		getArtistCollectionsWorks({commit,dispatch}, filter) {
		  if (window.is_vue_log) console.log('actions: '+'getArtistCollectionsworks');

			return new Promise((resolve, reject) => {
				var url = '/action/vue/artists/collections-list-works';

				api.post(url, filter).then(response => {
					commit('GET_ARTIST_COLLECTIONS_WORKS',response.data);
					resolve();
				}).catch(e => {
					console.log(e);
					reject();
				})
			})
		},

		getGalleryCollections({commit,dispatch}, filter) {
		  if (window.is_vue_log) console.log('actions: '+'getGalleryCollections');

			return new Promise((resolve, reject) => {
				var url = '/action/vue/galleries/collections-list';

				api.get(url, filter).then(response => {
					commit('GET_GALLERY_COLLECTIONS',response.data);
					resolve();
				}).catch(e => {
					console.log(e);
					reject();
				})
			})
		},
		getGalleryCollectionsWorks({commit,dispatch}, filter) {
		  if (window.is_vue_log) console.log('actions: '+'getGalleryCollectionsworks');

			return new Promise((resolve, reject) => {
				var url = '/action/vue/galleries/collections-list-works';

				api.post(url, filter).then(response => {
					commit('GET_GALLERY_COLLECTIONS_WORKS',response.data);
					resolve();
				}).catch(e => {
					console.log(e);
					reject();
				})
			})
		},

		getWorksRecently({commit,dispatch}, filter) {
		  if (window.is_vue_log) console.log('actions: '+'getWorksRecently');

			return new Promise((resolve, reject) => {
				var url = '/action/vue/works/recently';
				api.get(url, {}, this.state.route.name).then(response => {
					commit('GET_WORKS_RECENTLY',response.data);
					resolve();
				}).catch(e => {
					console.log(e);
					reject();
				})
			})
		},

		getWorksFeatured({commit,dispatch}, filter) {
		  if (window.is_vue_log) console.log('actions: '+'getWorksFeatured');

			return new Promise((resolve, reject) => {
				var url = '/action/vue/works/featured';
				api.get(url).then(response => {
					commit('GET_WORKS_FEATURED',response.data);
					resolve();
				}).catch(e => {
					console.log(e);
					reject();
				})
			})
		},

    setAdvanced({commit,dispatch},advanced){
      if (window.is_vue_log) console.log('actions: '+'setAdvanced');
      commit('SET_ADVANCED',advanced);
    },

		setFilters({commit,dispatch},filters){
      if (window.is_vue_log) console.log('actions: '+'setFilters');

			let is_scroll=false;
			if ( filters.scroll!=null ) is_scroll=filters.scroll;
			this.state.is_scroll=is_scroll;

			commit('SET_FILTERS',filters);

      if ( $('#app-wrapper').attr('router')=='sets' ){
        dispatch('getSets');
      }
      else if ( $('#app-wrapper').attr('router')=='artists' || $('#app-wrapper').attr('router')=='subdomain_gallery_artists' ){
        dispatch('getArtists');
      }
			else {
        dispatch('getWorks');
      }
		},
    resetFilters({commit,dispatch}){
      if (window.is_vue_log) console.log('actions: '+'resetFilters');

      commit('SET_FILTERS',this.state.filters);
    },

    addUsedFilters({commit,dispatch}, filter_name){
      if (window.is_vue_log) console.log('actions: '+'addUsedFilters');

      this.state.usedFilters.push(filter_name);
    },
    removeUsedFilters({commit,dispatch}, filter_name){
      if (window.is_vue_log) console.log('actions: '+'removeUsedFilters');

      let index = this.state.usedFilters.indexOf(filter_name);
      if (index > -1) this.state.usedFilters.splice(index, 1);
    },

    //ставим в конце пути /map
    setModificator({commit,dispatch}, modificator){
      if (window.is_vue_log) console.log('actions: '+'setModificator');

      let modificators=this.state.modificators;
      if ( modificators[modificator]==null ) modificators[modificator]=1;

      commit('SET_MODIFICATORS', modificators);
      this.state.dont_update_route=true;
      commit('SET_FILTERS', {any_val:1});//чтобы обновился роут (все рано цифры пропускаются)
      this.state.dont_update_route=false;
    },
    removeModificator({commit,dispatch}, modificator){
      if (window.is_vue_log) console.log('actions: '+'removeModificator');

      let modificators=this.state.modificators;
      if ( modificators[modificator]!=null ) delete modificators[modificator];

      commit('SET_MODIFICATORS', modificators);
      this.state.dont_update_route=true;
      commit('SET_FILTERS', {any_val:1});//чтобы обновился роут (все рано цифры пропускаются)
      this.state.dont_update_route=false;
    },

		getWorks({commit,dispatch}, filter) {
      if (window.is_vue_log) console.log('actions: '+'getWorks');
			let is_scroll=this.state.is_scroll;
			let is_set_loading=true;

			if (is_set_loading) commit('SET_WORKS_LOADING',true);
			if (is_scroll) {
        window.scrol_to_obj( $('#id_main_works_list') );
			}

			let url = '/action/vue/works/search';

      //Разбираем фильтры
      commit('GET_FILTERS');
      let getParams = Object.assign({}, this.state.filters);
      if ( this.state.route.name=='MainWorks' || this.state.route.name=='_MainWorks' ){
        getParams =  Object.assign({'cnt':'8'}, getParams);
      }

			api.get(url, getParams, this.state.route.name).then(response => {
			  if ( response.data['replaces']!=null ){
			    let url=window.location.href;
          response.data['replaces'].forEach( (itm)=>{
            if ( itm['from']!=null && itm['to']!=null ){
              url=url.replace(itm['from'], itm['to']);
            }
          } );

          if ( url!=window.location.href ) {
            window.location.replace(url);
          }
			    else {
            window.show_err_mes( i18n.t("message.UnknownError") );
          }

			    return;
        }

				commit('GET_WORKS_TOTAL', response.data.total);
				commit('GET_WORKS',response.data.works);
				commit('GET_WFILTER',response.data.wfilter);
				commit('GET_WORKS_TOTAL_ON_MAP',response.data.total_on_map);
				commit('SET_WORKS_LOADING',false);

				//console.log(this.state.usedFilters.includes('Colors'));

				if (this.state.usedFilters.includes('Arttypes')) dispatch('getArttypes');
        if (this.state.usedFilters.includes('Saletypes')) dispatch('getSaletypes');
        if (this.state.usedFilters.includes('Countries')) dispatch('getCountries');
        if (this.state.usedFilters.includes('Colors')) dispatch('getColors');
        if (this.state.usedFilters.includes('FiltersCounts')) dispatch('getFiltersCounts');
        if (this.state.usedFilters.includes('Genres')) dispatch('getGenres');
        if (this.state.usedFilters.includes('Presets')) dispatch('getPresets');
        if (this.state.usedFilters.includes('Sizes')) dispatch('getSizes');
        if (this.state.usedFilters.includes('Styles')) dispatch('getStyles');
        if (this.state.usedFilters.includes('Techniques')) dispatch('getTechniques');
        if (this.state.usedFilters.includes('PlacesGalleries')) {
          dispatch('getPlaces');
          dispatch('getGalleries');
        }
        if (this.state.usedFilters.includes('Periods')) dispatch('getPeriods');
        if (this.state.usedFilters.includes('Prices')) dispatch('getPrices');
        dispatch('getSchools');//фильтра нет. только для вывода тега. проверка внутри
        dispatch('getMaterials');//фильтра нет. только для вывода тега. проверка внутри
			}).catch(e => {
				console.log(e);
				commit('SET_WORKS_LOADING',false);
			})
		},
		getWorksOnMap({commit,dispatch}, filter) {
      if (window.is_vue_log) console.log('actions: '+'getWorksOnMap');

			let url = '/action/vue/works/search_map';
			commit('GET_FILTERS'); //Разбирает фильтры из Url (RA перенёс сюда)

			let getParams = Object.assign(this.state.filters, filter);

      return new Promise((resolve, reject) => {
        api.get(url, getParams, this.state.route.name, true).then(response => {
          //commit('SET_WORKS_LOADING',false);
          commit('GET_WORKS_ON_MAP_TOTAL', response.data.total);
          commit('GET_WORKS_ON_MAP', response.data.works);
          resolve();
        }).catch(e => {
          console.log(e);
          //commit('SET_WORKS_LOADING',false);
          reject();
        })
      })
		},
		getWorksOnMapCluster({commit,dispatch}, filter) {
      if (window.is_vue_log) console.log('actions: '+'getWorksOnMapCluster');

			let url = '/action/vue/works/search_map_cluster';
			commit('GET_FILTERS'); //Разбирает фильтры из Url (RA перенёс сюда)

			let getParams = Object.assign(this.state.filters, filter);

      return new Promise((resolve, reject) => {
        api.get(url, getParams, this.state.route.name, true).then(response => {
          commit('GET_WORKS_ON_MAP_CLUSTER', response.data.works);
          commit('GET_WORKS_ON_MAP_CLUSTER_TOTAL', response.data.total);
          resolve();
        }).catch(e => {
          console.log(e);
          reject();
        })
      })
		},
    getWorksOnMapList({commit,dispatch}, filter) {
      if (window.is_vue_log) console.log('actions: '+'getWorksOnMapList');

			let url = '/action/vue/works/search_map_list';
			commit('GET_FILTERS'); //Разбирает фильтры из Url (RA перенёс сюда)

			let getParams = Object.assign(this.state.filters, filter);

      return new Promise((resolve, reject) => {
        api.get(url, getParams, this.state.route.name, true).then(response => {
          commit('GET_WORKS_ON_MAP_LIST', response.data.works);
          commit('GET_WORKS_ON_MAP_LIST_TOTAL', response.data.total);
          resolve();
        }).catch(e => {
          console.log(e);
          reject();
        })
      })
		},

    getSets({commit,dispatch}, filter) {
      if (window.is_vue_log) console.log('actions: '+'getSets');
      let is_scroll=this.state.is_scroll;
      let is_set_loading=true;

      if (is_set_loading) commit('SET_SETS_LOADING',true);
      if (is_scroll) {
        window.scrol_to_obj( $('#id_main_works_list') );
      }

      let url = '/action/vue/sets/search';

      //Разбираем фильтры
      commit('GET_FILTERS');
      let getParams = Object.assign({}, this.state.filters);

      api.get(url, getParams, this.state.route.name).then(response => {
        if ( response.data['replaces']!=null ){
          let url=window.location.href;
          response.data['replaces'].forEach( (itm)=>{
            if ( itm['from']!=null && itm['to']!=null ){
              url=url.replace(itm['from'], itm['to']);
            }
          } );

          if ( url!=window.location.href ) {
            window.location.replace(url);
          }
          else {
            window.show_err_mes( i18n.t("message.UnknownError") );
          }

          return;
        }

        commit('GET_SETS_TOTAL', response.data.total);
        commit('GET_SETS',response.data.sets);
        commit('SET_SETS_LOADING',false);

        if (this.state.usedFilters.includes('Arttypes')) dispatch('getArttypes');
        if (this.state.usedFilters.includes('Saletypes')) dispatch('getSaletypes');
        if (this.state.usedFilters.includes('Countries')) dispatch('getCountries');
        if (this.state.usedFilters.includes('Colors')) dispatch('getColors');
        if (this.state.usedFilters.includes('FiltersCounts')) dispatch('getFiltersCounts');
        if (this.state.usedFilters.includes('Genres')) dispatch('getGenres');
        if (this.state.usedFilters.includes('Presets')) dispatch('Presets');
        if (this.state.usedFilters.includes('Sizes')) dispatch('getSizes');
        if (this.state.usedFilters.includes('Styles')) dispatch('getStyles');
        if (this.state.usedFilters.includes('Techniques')) dispatch('getTechniques');
        if (this.state.usedFilters.includes('PlacesGalleries')) {
          dispatch('getPlaces');
          dispatch('getGalleries');
        }
        if (this.state.usedFilters.includes('Periods')) dispatch('getPeriods');
        if (this.state.usedFilters.includes('Prices')) dispatch('getPrices');
        dispatch('getSchools');//фильтра нет. только для вывода тега. проверка внутри
        dispatch('getMaterials');//фильтра нет. только для вывода тега. проверка внутри
      }).catch(e => {
        console.log(e);
        commit('SET_SETS_LOADING',false);
      })
    },

    getArtists({commit,dispatch}, filter) {
      if (window.is_vue_log) console.log('actions: '+'getArtists');
      let is_scroll=this.state.is_scroll;
      let is_set_loading=true;

      if (is_set_loading) commit('SET_ARTISTS_LOADING',true);
      if (is_scroll) {
        window.scrol_to_obj( $('#id_main_works_list') );
      }

      let url = '/action/vue/artists/search';

      //Разбираем фильтры
      commit('GET_FILTERS');
      let getParams = Object.assign({}, this.state.filters);

      api.get(url, getParams, this.state.route.name).then(response => {
        if ( response.data['replaces']!=null ){
          let url=window.location.href;
          response.data['replaces'].forEach( (itm)=>{
            if ( itm['from']!=null && itm['to']!=null ){
              url=url.replace(itm['from'], itm['to']);
            }
          } );

          if ( url!=window.location.href ) {
            window.location.replace(url);
          }
          else {
            window.show_err_mes( i18n.t("message.UnknownError") );
          }

          return;
        }

        commit('GET_ARTISTS_TOTAL', response.data.total);
        commit('GET_ARTISTS',response.data.artists);
        commit('SET_ARTISTS_LOADING',false);

        if (this.state.usedFilters.includes('Arttypes')) dispatch('getArttypes');
        if (this.state.usedFilters.includes('Saletypes')) dispatch('getSaletypes');
        if (this.state.usedFilters.includes('Countries')) dispatch('getCountries');
        if (this.state.usedFilters.includes('Colors')) dispatch('getColors');
        if (this.state.usedFilters.includes('FiltersCounts')) dispatch('getFiltersCounts');
        if (this.state.usedFilters.includes('Genres')) dispatch('getGenres');
        if (this.state.usedFilters.includes('Presets')) dispatch('Presets');
        if (this.state.usedFilters.includes('Sizes')) dispatch('getSizes');
        if (this.state.usedFilters.includes('Styles')) dispatch('getStyles');
        if (this.state.usedFilters.includes('Techniques')) dispatch('getTechniques');

        if (this.state.usedFilters.includes('Periods')) dispatch('getPeriods');
        if (this.state.usedFilters.includes('Prices')) dispatch('getPrices');

        dispatch('getSchools');//фильтра нет. только для вывода тега. проверка внутри
        dispatch('getMaterials');//фильтра нет. только для вывода тега. проверка внутри
        dispatch('getPlaces');//фильтра нет. только для вывода тега. проверка внутри
      }).catch(e => {
        console.log(e);
        commit('SET_ARTISTS_LOADING',false);
      })
    },

    setSeoTitle({commit,dispatch}, txt){
      if (window.is_vue_log) console.log('actions: '+'setSeoTitle');
      commit('SET_SEO_TITLE', txt);
    },
    setSeoText({commit,dispatch}, txt){
      if (window.is_vue_log) console.log('actions: '+'setSeoText');
      commit('SET_SEO_TEXT', txt);
    },

		removeTag({commit,dispatch},tag){
      if (window.is_vue_log) console.log('actions: '+'removeTag');
			commit('REMOVE_TAG', tag);
			var filters = {}
			if(Array.isArray(this.state.filters[tag.key])){
				var arr_tags = []
				var filter = this.state.filters[tag.key]
				filter.forEach((el)=>{
					if(el !== tag.value){
						arr_tags.push(el)
					}
				})
				filters[tag.key] = arr_tags
			}else{
				filters[tag.key] = ''
			}
      filters['p']=1;
			commit('SET_FILTERS',filters);

      if ( $('#app-wrapper').attr('router')=='sets' ){
        dispatch('getSets');
      }
      else if ( $('#app-wrapper').attr('router')=='artists' ){
        dispatch('getArtists');
      }
      else {
        dispatch('getWorks');
      }
		},
		setTags({commit,dispatch},tags){
      if (window.is_vue_log) console.log('actions: '+'setTags');
			commit('SET_TAG', tags);
		},
		setPushWorks({commit}, pushWorks){
      if (window.is_vue_log) console.log('actions: '+'setPushWorks');
			commit('SET_PUSH_WORKS', pushWorks);
		},

    removeTags({commit,dispatch}, exclude_filters){
      if (window.is_vue_log) console.log('actions: '+'removeTags');

      commit('REMOVE_TAGS');
      commit('REMOVE_FILTERS', exclude_filters);

      var filters = {};
      filters['p']=1;
      commit('SET_FILTERS', filters);

      if ( $('#app-wrapper').attr('router')=='sets' ){
        dispatch('getSets');
      }
      else if ( $('#app-wrapper').attr('router')=='artists' ){
        dispatch('getArtists');
      }
      else {
        dispatch('getWorks');
      }
    },

		getUserId({commit}){
      if (window.is_vue_log) console.log('actions: '+'getUserId');
			let url = '/action/vue/users/get-current-id';

			api.get(url, {}).then(response => {
				commit('SET_USER_ID', response.data.id);
				commit('SET_USER_ARTIST_ID', response.data.artist_id);
				commit('SET_USER_CURRENCY', response.data.currency);
				commit('SET_IS_USER_HAS_PRO', response.data.is_user_has_pro);
				commit('SET_IS_USER_HAS_PAYOUT', response.data.is_user_has_payout);
				commit('SET_IS_USER_EDITOR', response.data.is_user_editor);
			}).catch(e => {
				console.log(e)
			})
		},

		getArttypes({commit,dispatch}){
      if (window.is_vue_log) console.log('actions: '+'getArttypes');

			var url = '/action/vue/types/search';
			var values = [];

      //установленый текущий фильтр убираем при построении запроса
      let filters = Object.assign({},this.state.filters);

      api.get(url, filters, this.state.route.name).then(response => {
        response.data.map((res,index)=>{
          values.push({label: res.name, value: ''+res.name_hash, cnt:+res.count, media_id:res.media_id, media:res.media})
        });

				commit('SET_ARTTYPES',values);

				var arttype = this.state.filters.type;
        var arr_tags = [];
				if ( arttype!=null ){
          values.forEach((vel)=>{
            if(arttype === vel.value){
              arr_tags.push({ key: vel.value, value: vel.label})
            }
          })
				}
				dispatch ('setTags', {type: arr_tags});

			}).catch(e => {
				console.log(e);
			})
		},

		getSaletypes({commit,dispatch}){
      if (window.is_vue_log) console.log('actions: '+'getSaletypes');

			var url = '/action/vue/saletypes/search';
			var values = [];

      //установленый текущий фильтр убираем при построении запроса
      let filters = Object.assign({},this.state.filters);

      api.get(url, filters, this.state.route.name).then(response => {
        response.data.map((res,index)=>{
          values.push({label: res.label, value: ''+res.value, cnt:+res.cnt})
        });

				commit('SET_SALETYPES',values);

				var saletype = this.state.filters.saletype;
        var arr_tags = [];
				if ( saletype!=null ){
          values.forEach((val)=>{
            if(saletype === val.value){
              arr_tags.push({ key: val.value, value: val.label})
            }
          })
					if ( saletype==='all' ){
						arr_tags.push({ key: 'all', value: i18n.t("message.AllWorksSale")})
					}
				}
				dispatch ('setTags', {saletype: arr_tags});

			}).catch(e => {
				console.log(e);
			})
		},

    getCountries({commit,dispatch}){
      if (window.is_vue_log) console.log('actions: '+'getCountries');

      var url = '/action/vue/countries/search';
      var values = [];

      //установленый текущий фильтр убираем при построении запроса
      let filters = Object.assign({},this.state.filters);

      api.get(url, filters, this.state.route.name).then(response => {
        response.data.map((res,index)=>{
          values.push({label: res.name, value: ''+res.cc})
        })
        commit('SET_COUNTRIES',values);

        var country = this.state.filters.country;
        var arr_tags = [];
        if (country!=null){
          if ( !Array.isArray(country) ) country=[country];

          country.forEach((el,index)=>{
            values.forEach((vel)=>{
              if(el === vel.value){
                arr_tags.push({ key: vel.value, value: vel.label})
              }
            })
          })
        }
        dispatch ('setTags', {country: arr_tags});

      }).catch(e => {
        console.log(e)
      })
    },

    getColors({commit,dispatch}){
      if (window.is_vue_log) console.log('actions: '+'getColors');

      var url = '/action/vue/colors/search';
      var values = [];

      //установленый текущий фильтр убираем при построении запроса
      let filters = Object.assign({},this.state.filters);

      api.get(url, filters, this.state.route.name).then(response => {
        /*response.data.map((res,index)=>{
          if(res.length>0) {
            values.push({label: res, value: '' + res})
          }
        })*/
        let hexcolors=[];
        let allcolors=['ffd800', 'ee5555', 'c69c6d', '00bff3', '7cc576', '754c24', 'acc29c', '475556', '52bbb2', 'f06eaa', 'f68e56', '297ad4', '2e3192', '00ffff'];
        response.data.map((res,index)=>{
          let deccolor=res.hex;
          hexcolors.push( deccolor.toString(16) );
        })
        allcolors.map( (cur_color)=>{
          if ( hexcolors.indexOf(cur_color)!=-1 ) values.push({label: cur_color, value: '' + cur_color});
        } );
        commit('SET_COLORS',values);

        var color = this.state.filters.color;
        var arr_tags = [];
        if (color!=null){
          if ( !Array.isArray(color) ) color=[color];

          color.forEach((el,index)=>{
            values.forEach((vel)=>{
              if(el === vel.value){
                arr_tags.push({ key: vel.value, value: vel.label})
              }
            })
          })
        }
        dispatch ('setTags', {color: arr_tags});
      }).catch(e => {
        console.log(e)
      })
    },

    getFiltersCounts({commit,dispatch}){
      if (window.is_vue_log) console.log('actions: '+'getFilterscounts');

      var url = '/action/vue/filters/counts';
      var values = [];

      //установленый текущий фильтр убираем при построении запроса
      let filters = Object.assign({},this.state.filters);

      api.get(url, filters, this.state.route.name).then(response => {
        commit('SET_FILTERS_COUNTS', response.data);
      }).catch(e => {
        console.log(e)
      })
    },

    getGenres({commit,dispatch}){
      if (window.is_vue_log) console.log('actions: '+'getGenres');

      var url = '/action/vue/genres/search';
      var values = [];

      //установленый текущий фильтр убираем при построении запроса
      let filters = Object.assign({},this.state.filters);

      api.get(url, filters, this.state.route.name).then(response => {
        response.data.map((res,index)=>{
          values.push({label: res.name, value: ''+res.name_hash})
        })
        commit('SET_GENRES',values);

        var genre = this.state.filters.genre;
        var arr_tags = [];
        if (genre!=null){
          if ( !Array.isArray(genre) ) genre=[genre];

          genre.forEach((el,index)=>{
            values.forEach((vel)=>{
              if(el === vel.value){
                arr_tags.push({ key: vel.value, value: vel.label})
              }
            })
          })
        }
        dispatch ('setTags', {genre: arr_tags});
      }).catch(e => {
        console.log(e)
      })
    },

    getPresets({commit,dispatch}){
      if (window.is_vue_log) console.log('actions: '+'Presets');

      var url = '/action/vue/presets/search';
      var values = [];

      //установленый текущий фильтр убираем при построении запроса
      let filters = Object.assign({},this.state.filters);

      api.get(url, filters, this.state.route.name).then(response => {
        response.data.map((res,index)=>{
          values.push({label: res.name, value: ''+res.filter_id, media: res['media']})
        })
        commit('SET_PRESETS',values);

        var preset = this.state.filters.preset;
        var arr_tags = [];
        if (preset!=null){
          if ( !Array.isArray(preset) ) preset=[preset];

          preset.forEach((el,index)=>{
            values.forEach((vel)=>{
              if(el === vel.value){
                arr_tags.push({ key: vel.value, value: vel.label})
              }
            })
          })
        }
        dispatch ('setTags', {preset: arr_tags});
      }).catch(e => {
        console.log(e)
      })
    },

    getSizes({commit,dispatch}){
      if (window.is_vue_log) console.log('actions: '+'getSizes');

      var url = '/action/vue/sizes/search';
      var values = [];

      //установленый текущий фильтр убираем при построении запроса
      let filters = Object.assign({},this.state.filters);

      api.get(url, filters, this.state.route.name).then(response => {
        /*response.data.map((res,index)=>{
          values.push({label: res.label, value: res.key})
        })*/

        let realsizes=[];
        let allrealsizes=['small', 'normal', 'big', 'biggest'];
        response.data.map((res,index)=>{
          /*if (res.count>0)*/ realsizes.push( res.key );
        })
        allrealsizes.map( (cur_key)=>{
          if ( realsizes.indexOf(cur_key)!=-1 ) values.push({label: i18n.t("message.Size"+cur_key), value: '' + cur_key});
        } );
        commit('SET_SIZES',values);

        var size = this.state.filters.size;
        var arr_tags = [];
        if (size!=null){
          if ( !Array.isArray(size) ) size=[size];

          size.forEach((el,index)=>{
            values.forEach((vel)=>{
              if(el === vel.value){
                arr_tags.push({ key: vel.value, value: vel.label})
              }
            })
          })
        }
        dispatch ('setTags', {size: arr_tags});
      }).catch(e => {
        console.log(e)
      })
    },

    getStyles({commit,dispatch}){
      if (window.is_vue_log) console.log('actions: '+'getStyles');

      var url = '/action/vue/styles/search';
      var values = [];

      //установленый текущий фильтр убираем при построении запроса
      let filters = Object.assign({},this.state.filters);

      api.get(url, filters, this.state.route.name).then(response => {
        response.data.map((res,index)=>{
          values.push({label: res.name, value: ''+res.name_hash})
        })
        commit('SET_STYLES',values);

        var style = this.state.filters.style;
        var arr_tags = [];
        if (style!=null){
          if ( !Array.isArray(style) ) style=[style];

          style.forEach((el,index)=>{
            values.forEach((vel)=>{
              if(el === vel.value){
                arr_tags.push({ key: vel.value, value: vel.label})
              }
            })
          })
        }
        dispatch ('setTags', {style: arr_tags});
      }).catch(e => {
        console.log(e)
      })
    },

    getTechniques({commit,dispatch}){
      if (window.is_vue_log) console.log('actions: '+'getTechniques');

      var url = '/action/vue/techniques/search';
      var values = [];

      //установленый текущий фильтр убираем при построении запроса
      let filters = Object.assign({},this.state.filters);

      api.get(url, filters, this.state.route.name).then(response => {
        response.data.map((res,index)=>{
          values.push({label: res.name, value: ''+res.name_hash})
        })
        commit('SET_TECHNIQUES',values);

        var technique = this.state.filters.technique;
        var arr_tags = [];
        if (technique!=null){
          if ( !Array.isArray(technique) ) technique=[technique];

          technique.forEach((el,index)=>{
            values.forEach((vel)=>{
              if(el === vel.value){
                arr_tags.push({ key: vel.value, value: vel.label})
              }
            })
          })
        }
        dispatch ('setTags', {technique: arr_tags});

      }).catch(e => {
        console.log(e)
      })
    },

    getPlaces({commit,dispatch}){
      if (window.is_vue_log) console.log('actions: '+'getPlaces');

      var url = '/action/vue/places/search';
      var values = [];

      //установленый текущий фильтр убираем при построении запроса
      let filters = Object.assign({},this.state.filters);

      api.get(url, filters, this.state.route.name).then(response => {
        response.data.map((res,index)=>{
          values.push({label: res.name, value: ''+res.place_id, count: parseInt(res.count)})
        })

        commit('SET_PLACES',values);

        var place = this.state.filters.place;
        var arr_tags = [];
        if (place!=null){
          if ( !Array.isArray(place) ) place=[place];

          place.forEach((el,index)=>{
            values.forEach((vel)=>{
              if(el === vel.value){
                arr_tags.push({ key: vel.value, value: vel.label})
              }
            })
          })
        }
        dispatch ('setTags', {place: arr_tags});

      }).catch(e => {
        console.log(e)
      })
    },

    getGalleries({commit,dispatch}){
		  if ( $('#app-wrapper').attr('gallery_id')>0 ) return;
      if (window.is_vue_log) console.log('actions: '+'getGalleries');

      var url = '/action/vue/galleries/search';
      var values = [];

      //установленый текущий фильтр убираем при построении запроса
      let filters = Object.assign({},this.state.filters);

      api.get(url, filters, this.state.route.name).then(response => {
        response.data.map((res,index)=>{
          values.push({label: res.name, value: ''+res.gallery_id, count: parseInt(res.count) })
        })

        commit('SET_GALLERIES',values);

        var gallery = this.state.filters.gallery;
        var arr_tags = [];
        if (gallery!=null){
          if ( !Array.isArray(gallery) ) gallery=[gallery];

          gallery.forEach((el,index)=>{
            values.forEach((vel)=>{
              if(el === vel.value){
                arr_tags.push({ key: vel.value, value: vel.label})
              }
            })
          })
        }
        dispatch ('setTags', {gallery: arr_tags});

      }).catch(e => {
        console.log(e)
      })
    },

    getSchools({commit,dispatch}){
      if (window.is_vue_log) console.log('actions: '+'getSchools');

      var url = '/action/vue/schools/search_hash';//запрашиваем только выбранные
      var values = [];

      if ( this.state.filters.school==null || this.state.filters.school.length==0 ) return;

      api.get(url, {'hash':this.state.filters.school}, false).then(response => {
        if ( typeof response.data === 'object' ){
          response.data.map((res,index)=>{
            values.push({label: res.name, value: ''+res.name_hash})
          });
        }

        commit('SET_SCHOOLS',values);

        var school = this.state.filters.school;
        var arr_tags = [];
        if (school!=null){
          if ( !Array.isArray(school) ) school=[school];

          school.forEach((el,index)=>{
            values.forEach((vel)=>{
              if(el === vel.value){
                arr_tags.push({ key: vel.value, value: vel.label})
              }
            })
          })
        }
        dispatch ('setTags', {school: arr_tags});

      }).catch(e => {
        console.log(e)
      })
    },

    getMaterials({commit,dispatch}){
      if (window.is_vue_log) console.log('actions: '+'getMaterials');

      var url = '/action/vue/materials/search_hash';//запрашиваем только выбранные
      var values = [];

      if ( this.state.filters.material==null || this.state.filters.material.length==0 ) return;

      api.get(url, {'hash':this.state.filters.material}, false).then(response => {
        if ( typeof response.data === 'object' ){
          response.data.map((res,index)=>{
            values.push({label: res.name, value: ''+res.name_hash})
          });
        }

        commit('SET_MATERIALS',values);

        var material = this.state.filters.material;
        var arr_tags = [];
        if (material!=null){
          if ( !Array.isArray(material) ) material=[material];

          material.forEach((el,index)=>{
            values.forEach((vel)=>{
              if(el === vel.value){
                arr_tags.push({ key: vel.value, value: vel.label})
              }
            })
          })
        }
        dispatch ('setTags', {material: arr_tags});

      }).catch(e => {
        console.log(e)
      })
    },

    getPeriods({commit,dispatch}){
      if (window.is_vue_log) console.log('actions: '+'getPeriods');

      var url = '/action/vue/periods/search';
      var values = {};

      //установленый текущий фильтр убираем при построении запроса
      let filters = Object.assign({},this.state.filters);

      api.get(url, filters, this.state.route.name).then(response => {
        if ( response.data['min_from']>0 && response.data['max_to']>0 ){
          values['min_from']=response.data['min_from'];
          values['max_to']=response.data['max_to'];
          values['period_min']=response.data['period_min'];
          values['period_max']=response.data['period_max'];
        }
        commit('SET_PERIODS',values);
      }).catch(e => {
        console.log(e)
      })
    },

    getPrices({commit,dispatch}){
      if (window.is_vue_log) console.log('actions: '+'getPrices');
      //console.log('actions: '+'getPrices', this.state.filters.price_min, this.state.filters.price_max);

      var url = '/action/vue/prices/search';
      var values = {};

      //установленый текущий фильтр убираем при построении запроса
      let filters = Object.assign({},this.state.filters);

      api.get(url, filters, this.state.route.name).then(response => {
        values=Object.assign({},response.data);
        commit('SET_PRICES',values);
      }).catch(e => {
        console.log(e)
      })
    },

  },

	mutations: {
    GET_ARTIST_COLLECTIONS(state, res) {
      if (window.is_vue_log) console.log('mutations: '+'GET_ARTIST_COLLECTIONS');
			state.artistCollections = res;

			let sel_acollection=state.filters.acollection;
			if ( sel_acollection!=null && sel_acollection>0 ){
			  let is_enable=false;
			  if ( state.artistCollections!=null && state.artistCollections['artist_sets']!=null ){
          state.artistCollections['artist_sets'].forEach((el)=>{
            if(el.set_id == sel_acollection){
              is_enable=true;
            }
          });
        }

			  if ( !is_enable ){
			    //у нас нет такого
          this.dispatch('setFilters', {'p':1, acollection: false}).then (() => { });
        }
      }
		},
    GET_ARTIST_COLLECTIONS_WORKS(state, res) {
      if (window.is_vue_log) console.log('mutations: '+'GET_ARTIST_COLLECTIONS_WORKS');
      let result=[];
      res['artist_works_set_ids'].forEach( function(o, n){
        result.push( parseInt(o) );
      } );
			state.artistCollectionsWorks = result;
		},

    GET_GALLERY_COLLECTIONS(state, res) {
      if (window.is_vue_log) console.log('mutations: '+'GET_GALLERY_COLLECTIONS');
			state.galleryCollections = res;

			let sel_gcollection=state.filters.gcollection;
			if ( sel_gcollection!=null && sel_gcollection>0 ){
			  let is_enable=false;
			  if ( state.galleryCollections!=null && state.galleryCollections['gallery_sets']!=null ){
          state.galleryCollections['gallery_sets'].forEach((el)=>{
            if(el.set_id == sel_gcollection){
              is_enable=true;
            }
          });
        }

			  if ( !is_enable ){
			    //у нас нет такого
          this.dispatch('setFilters', {'p':1, gcollection: false}).then (() => { });
        }
      }
		},
    GET_GALLERY_COLLECTIONS_WORKS(state, res) {
      if (window.is_vue_log) console.log('mutations: '+'GET_GALLERY_COLLECTIONS_WORKS');
      let result=[];
      res['gallery_works_set_ids'].forEach( function(o, n){
        result.push( parseInt(o) );
      } );
			state.galleryCollectionsWorks = result;
		},

		GET_WORKS_RECENTLY(state, works) {
      if (window.is_vue_log) console.log('mutations: '+'GET_WORKS_RECENTLY');
			state.worksRecently = works
		},
    GET_WORKS_FEATURED(state, works) {
      if (window.is_vue_log) console.log('mutations: '+'GET_WORKS_FEATURED');
			state.worksFeatured = works
		},
		GET_WORKS(state, works) {
      if (window.is_vue_log) console.log('mutations: '+'GET_WORKS');
			if (state.pushWorks) {
				state.works = state.works.concat(works)
			} else {
				state.works = works
			}
		},
    GET_WFILTER(state, wfilter) {
      if (window.is_vue_log) console.log('mutations: '+'GET_WFILTER');
      state.wfilter = wfilter
		},
    GET_WORKS_TOTAL_ON_MAP(state, total_on_map) {
      if (window.is_vue_log) console.log('mutations: '+'GET_WORKS_TOTAL_ON_MAP');
      state.worksTotalOnMap = total_on_map
		},
		GET_WORKS_TOTAL(state, worksTotal) {
			state.worksTotal = worksTotal
		},

    GET_SETS(state, sets) {
      if (window.is_vue_log) console.log('mutations: '+'GET_SETS');
      /*if (state.pushWorks) {
        state.works = state.works.concat(works)
      } else {*/
        state.sets = sets
      //}
    },
    GET_ARTISTS(state, artists) {
      if (window.is_vue_log) console.log('mutations: '+'GET_ARTISTS');
      /*if (state.pushWorks) {
        state.works = state.works.concat(works)
      } else {*/
        state.artists = artists
      //}
    },
    GET_SETS_TOTAL(state, setsTotal) {
      state.setsTotal = setsTotal
    },
    GET_ARTISTS_TOTAL(state, artistsTotal) {
      state.artistsTotal = artistsTotal
    },

    GET_WORKS_ON_MAP(state, works) {
      state.works_on_map = works;
    },
    GET_WORKS_ON_MAP_TOTAL(state, worksTotal) {
      state.works_on_map_total = worksTotal;
    },
    GET_WORKS_ON_MAP_CLUSTER(state, works) {
      state.works_on_map_cluster = works;
    },
    GET_WORKS_ON_MAP_CLUSTER_TOTAL(state, total) {
      state.works_on_map_cluster_total = total;
    },
    GET_WORKS_ON_MAP_LIST(state, works) {
      state.works_on_map_list = works;
    },
    GET_WORKS_ON_MAP_LIST_TOTAL(state, total) {
      state.works_on_map_list_total = total;
    },

		GET_FILTERS(state){
      if (window.is_vue_log) console.log('mutations: '+'GET_FILTERS');

			if(undefined !== state.route.params.filter && state.route.params.filter.length > 0) {
				let filterstmp = {};
				let modificators_tmp = {};

				state.route.params.filter.split ('-').forEach ((el) => {
					var tmp = el.split (':');
					if (Array.isArray (tmp) && undefined !== tmp[0] && tmp[0].length > 0) {
						if (undefined === tmp[1]) {
							tmp[1] = true;
						}
            else {
						  if ( tmp[0]==='name' || tmp[0]==='search' || tmp[0]==='preset' ){
						    //не может быть массивом
                tmp[1]=tmp[1].replace(',', '~2C');
              }

              tmp[1] = tmp[1].split(",").arrdecode();
						}
						filterstmp[tmp[0]] = tmp[1];
					}
				});
				if ( filterstmp.p == null ) filterstmp.p=1;

				let array_filters=['size', 'country', 'genre', 'style', 'technique', 'place', 'gallery', 'school', 'material', 'tag'];
				array_filters.forEach( function(array_filter){
					if ( filterstmp[array_filter]!=null && !Array.isArray(filterstmp[array_filter]) ) filterstmp[array_filter]=[filterstmp[array_filter]];
				} );

				let array_modificators=['map'];
        array_modificators.forEach( function(array_modificator){
					if ( filterstmp[array_modificators]!=null && !Array.isArray(filterstmp[array_modificators]) ) modificators_tmp[array_modificators]=1;
				} );

				let is_reset_filters=false;
				if ( filterstmp['search']!=null && filterstmp['search'].length>0 ){
          filterstmp['name']=filterstmp['search'];
          delete filterstmp.search;
          is_reset_filters=true;
        }
        //console.log(filterstmp);

				state.filters = filterstmp;
				state.modificators = modificators_tmp;

        if (is_reset_filters) {
          this.dispatch('resetFilters');
        }
			}
			else {
			  //чтобы при переходе в браузере кнопкой назад отрабатывала перерисовка на странице без фильтра
        state.filters = {};
        state.tags = {};
        state.modificators = {};
      }
		},
		REMOVE_TAG(state, tag){
      if (window.is_vue_log) console.log('mutations: '+'REMOVE_TAG');
			if (state.tags[tag.key] !== undefined) {
				var tags = Object.assign({},state.tags)
				Object.keys(state.tags).map(function(objectKey, index) {
					if(objectKey === tag.key){
						var value = tags[objectKey]
						if(Array.isArray(value)){
							value.forEach((el, index) => {
								if (el.key === tag.value) {
									tags[objectKey].splice(index, 1);
								}
							})
						}else{
							delete tags[objectKey];
						}
					}
				})
				state.tags = tags
			}
		},
		SET_TAG(state,tags){
      if (window.is_vue_log) console.log('mutations: '+'SET_TAG');
			tags = Object.assign(state.tags,tags);
			Object.keys(tags).map(function (objectKey, index) {
				if(Array.isArray(tags[objectKey])){
					tags[objectKey].forEach((el,index) => {
						if(undefined === el.key || el.key.length === 0 || undefined === el.value || el.value.length === 0){
							delete tags[objectKey][index];
						}
					})
				}else if(undefined === tags[objectKey].key || tags[objectKey].key.length === 0){
					delete tags[objectKey];
				}
			});
			state.tags = Object.assign({},tags);
		},
    REMOVE_TAGS(state){
      if (window.is_vue_log) console.log('mutations: '+'REMOVE_TAGS');
      state.tags = {};
    },

		SET_FILTERS(state,filters){
      if (window.is_vue_log) console.log('mutations: '+'SET_FILTERS');
			var filter_params =[];
			var renew = false;
			var sfilters = Object.assign(state.filters,filters);

			Object.keys(sfilters).map(function (objectKey, index) {
				var value = sfilters[objectKey];

        //console.log(objectKey);console.log(typeof value);

				//если значение значимое, то в value приходит строка или объект.
        // Любые числа и bool игнорятся и удаляются из фильтра!
				if (undefined!==value && value.length>0) {
					if(objectKey === 'p' && parseInt(value) <= 1){
						return;
					}

          //недолжно быть массивом
          if ( objectKey==='saletype' && Array.isArray(value) ) value=value[0];
          if ( objectKey==='type' && Array.isArray(value) ) value=value[0];
          if ( objectKey==='preset' && Array.isArray(value) ) value=value[0];

					switch (typeof value) {
						case 'object':
							if(Array.isArray(value)){
							  let a=[];
								filter_params.push( objectKey + ":" + a.concat(value.arrencode()).join(',')+',' );
							}
							// по факту не выполнимое условие
							// else{
							//     var tmparr = [];
							//     Object.keys(value).map(function (vkey, vind) {
							//       if(vind){
							//           tmparr.push(vkey)
							//       }
							//     })
							//     filter_params.push (objectKey + ":" + tmparr.arrencode().join(',')+',');
							// }
            break;
						case 'string':
							filter_params.push (objectKey + ":" + value.str_escape ());
            break;
						default:
							filter_params.push (objectKey + ":" + value);
            break;
					}
				}
				else {
					delete sfilters[objectKey];
					renew = true;
				}
			});

      Object.keys(state.modificators).map(function(modificator, index) {
        filter_params.push(modificator);
      });

      //console.log(filter_params);

      let cur_route_name=state.route.name;

      /*Begin меняем cur_route_name, если мы на главной и показываем работы в продаже*/
      if ( ['AllWorks', '_AllWorks', 'SaleWorks', '_SaleWorks', 'PickedWorks', '_PickedWorks'].indexOf(cur_route_name)!=-1 ){
        let is_sale=false;
        let saletype_index_all=-1;
        let is_picked=false;
        let picked_index=-1;
        filter_params.forEach( (filter_param, indx)=>{
          if ( filter_param.indexOf('saletype:')===0 ) is_sale=true;
          if ( filter_param.indexOf('saletype:all')===0 ) saletype_index_all=indx;
          if ( filter_param.indexOf('picked:y')===0 ) {
            is_picked=true;
            picked_index=indx;
          }
        } );

        if ( is_sale ){
          if ( cur_route_name[0]==='_' ) cur_route_name='_SaleWorks';
          else cur_route_name='SaleWorks';
        }
        else if ( is_picked ){
          if ( cur_route_name[0]==='_' ) cur_route_name='_PickedWorks';
          else cur_route_name='PickedWorks';
        }
        else if ( window._gl_vue_change_route===true ) {
          if ( cur_route_name[0]==='_' ) cur_route_name='_AllWorks';
          else cur_route_name='AllWorks';
        }
        window._gl_vue_change_route=false;

        if ( is_sale && (cur_route_name==='SaleWorks' || cur_route_name==='_SaleWorks') && saletype_index_all!=-1 ) filter_params.splice(saletype_index_all, 1);
        if ( is_picked && (cur_route_name==='PickedWorks' || cur_route_name==='_PickedWorks') && picked_index!=-1 ) filter_params.splice(picked_index, 1);
      }
      /*End меняем route, если мы на главной и показываем работы в продаже*/

      let route_name='';
			if ('_' === cur_route_name[0]) {
				if (0 === filter_params.length) route_name = cur_route_name.replace ('_', '');
        else route_name = cur_route_name;
			}
      else {
        if (filter_params.length > 0) route_name = '_' + cur_route_name;
        else route_name = cur_route_name;
      }

      if (!jQuery.isEmptyObject(filters)){
        if('_' === route_name[0]) {
          var new_path=filter_params.join ('-');
          if ( state.dont_update_route ){
            //просто меняем адрес в браузере, без обновления компонент
            let found_route=null;
            window.vue_router.options.routes.forEach(route => {
              if ( route.name==route_name ) found_route=route;
            });

            if ( found_route!=null ){
              let url=found_route.path;
              url=url.replace( ':filter', new_path );
              window.history.pushState( null, null, url );
            }
          }
          else {
            window.vue_router.push ({name: route_name, params: {filter: new_path}});
          }
        }
        else {
          window.vue_router.push({name: route_name});
        }
      }

			if(renew){
				state.filters = Object.assign({},sfilters)
			}
		},
    REMOVE_FILTERS(state, exclude_filters){
      if (window.is_vue_log) console.log('mutations: '+'REMOVE_TAGS');

      if ( exclude_filters==null ) exclude_filters=[];
      exclude_filters.push('sort');

      let save={};
      exclude_filters.forEach( (one_filter)=>{
        if ( state.filters[one_filter]!=null ) save[one_filter]=state.filters[one_filter];
      } );

      state.filters = {};
      state.filters = Object.assign(state.filters, save);
    },

    SET_MODIFICATORS(state, modificators){
      if (window.is_vue_log) console.log('mutations: '+'SET_MODIFICATORS');
      state.modificators=modificators;
		},

		SET_SEO_TITLE(state, txt){
      if (window.is_vue_log) console.log('mutations: '+'SET_SEO_TITLE');
			state.seo_title = txt;
		},
		SET_SEO_TEXT(state, txt){
      if (window.is_vue_log) console.log('mutations: '+'SET_SEO_TEXT');
			state.seo_text = txt;
		},

		SET_WORKS_LOADING(state,status){
      if (window.is_vue_log) console.log('mutations: '+'SET_WORKS_LOADING');
			state.worksLoading = status
		},
    SET_SETS_LOADING(state,status){
      if (window.is_vue_log) console.log('mutations: '+'SET_SETS_LOADING');
      state.setsLoading = status
    },
    SET_ARTISTS_LOADING(state,status){
      if (window.is_vue_log) console.log('mutations: '+'SET_ARTISTS_LOADING');
      state.artistsLoading = status
    },
		SET_ADVANCED(state,status){
      if (window.is_vue_log) console.log('mutations: '+'SET_ADVANCED');
			state.advanced = status
		},
		SET_PUSH_WORKS(state, pushWorks){
      if (window.is_vue_log) console.log('mutations: '+'SET_PUSH_WORKS');
			state.pushWorks = pushWorks
		},
		SET_USER_ID(state, userId){
      if (window.is_vue_log) console.log('mutations: '+'SET_USER_ID');
			state.userId = userId
		},
		SET_USER_ARTIST_ID(state, user_artist_id){
      if (window.is_vue_log) console.log('mutations: '+'SET_USER_ARTIST_ID');
			state.user_artist_id = user_artist_id
		},
    SET_USER_CURRENCY(state, user_currency){
      if (window.is_vue_log) console.log('mutations: '+'SET_USER_CURRENCY');
			state.user_currency = user_currency;
		},
    SET_IS_USER_HAS_PRO(state, is_user_has_pro){
      if (window.is_vue_log) console.log('mutations: '+'SET_IS_USER_HAS_PRO');
			state.is_user_has_pro = is_user_has_pro;
		},
    SET_IS_USER_HAS_PAYOUT(state, is_user_has_payout){
      if (window.is_vue_log) console.log('mutations: '+'SET_IS_USER_HAS_PAYOUT');
			state.is_user_has_payout = is_user_has_payout;
		},
    SET_IS_USER_EDITOR(state, is_user_editor){
      if (window.is_vue_log) console.log('mutations: '+'SET_IS_USER_EDITOR');
			state.is_user_editor = is_user_editor;
		},

		SET_ARTTYPES(state,arttypes){
      if (window.is_vue_log) console.log('mutations: '+'SET_ARTTYPES');
			state.arttypes = arttypes;
		},
		SET_SALETYPES(state,saletypes){
      if (window.is_vue_log) console.log('mutations: '+'SET_SALETYPES');
			state.saletypes = saletypes;
		},
		SET_COUNTRIES(state,countries){
      if (window.is_vue_log) console.log('mutations: '+'SET_COUNTRIES');
			state.countries = countries;
		},
		SET_COLORS(state,colors){
      if (window.is_vue_log) console.log('mutations: '+'SET_COLORS');
			state.colors = colors;
		},
		SET_FILTERS_COUNTS(state,values){
      if (window.is_vue_log) console.log('mutations: '+'SET_FILTERS_COUNTS');
			state.filters_counts = values;
		},
    SET_GENRES(state,genres){
      if (window.is_vue_log) console.log('mutations: '+'SET_GENRES');
      state.genres = genres;
    },
    SET_PRESETS(state,presets){
      if (window.is_vue_log) console.log('mutations: '+'SET_PRESETS');
      state.presets = presets;
    },
    SET_SIZES(state,sizes){
      if (window.is_vue_log) console.log('mutations: '+'SET_SIZES');
      state.sizes = sizes;
    },
    SET_STYLES(state,styles){
      if (window.is_vue_log) console.log('mutations: '+'SET_STYLES');
      state.styles = styles;
    },
    SET_TECHNIQUES(state,techniques){
      if (window.is_vue_log) console.log('mutations: '+'SET_TECHNIQUES');
      state.techniques = techniques;
    },
    SET_PLACES(state,places){
      if (window.is_vue_log) console.log('mutations: '+'SET_PLACES');
      state.places = places;
    },
    SET_GALLERIES(state,galleries){
      if (window.is_vue_log) console.log('mutations: '+'SET_GALLERIES');
      state.galleries = galleries;
    },
    SET_SCHOOLS(state,schools){
      if (window.is_vue_log) console.log('mutations: '+'SET_SCHOOLS');
      state.schools = schools;
    },
    SET_MATERIALS(state,materials){
      if (window.is_vue_log) console.log('mutations: '+'SET_MATERIALS');
      state.materials = materials;
    },
    SET_PERIODS(state,periods){
      if (window.is_vue_log) console.log('mutations: '+'SET_PERIODS');
      state.periods = periods;
    },
    SET_PRICES(state,prices){
      if (window.is_vue_log) console.log('mutations: '+'SET_PRICES');
      state.prices = prices;
    },
	},

	getters: {
    is_sale_selected: state => {
      if ( state.route.name=='SaleWorks' || state.route.name=='_SaleWorks' ) return true;

      if ( state.filters.saletype==null || state.filters.saletype===false || state.filters.saletype.length==0 || $.isEmptyObject(state.filters.saletype) ) return false;
      else return true;
    },

    is_my_selected: state => {
      if ( state.route.name=='MyWorks' || state.route.name=='_MyWorks' ) return true;

      return false;
    },

    is_liked_selected: state => {
      if ( state.route.name=='LikedWorks' || state.route.name=='_LikedWorks' ) return true;

      return false;
    },

    is_sale_enable: state => {
      if ( state.saletypes==null || state.saletypes===false || state.saletypes.length==0 || $.isEmptyObject(state.saletypes) ) return false;
      else return true;
    },

    seo_title: state => {
      return state.seo_title
    },
    seo_text: state => {
      return state.seo_text
    },

    artistCollections: state => {
			return state.artistCollections
		},
    artistCollectionsWorks: state => {
			return state.artistCollectionsWorks
		},

    galleryCollections: state => {
			return state.galleryCollections
		},
    galleryCollectionsWorks: state => {
			return state.galleryCollectionsWorks
		},

		worksRecently: state => {
			return state.worksRecently
		},
    worksFeatured: state => {
			return state.worksFeatured
		},
		works: state => {
			return state.works
		},
		wfilter: state => {
			return state.wfilter
		},
    worksTotalOnMap: state => {
			return state.worksTotalOnMap
		},

    works_on_map: state => {
      return state.works_on_map
    },
    works_on_map_total: state => {
      return state.works_on_map_total
    },
    works_on_map_cluster: state => {
      return state.works_on_map_cluster
    },
    works_on_map_cluster_total: state => {
      return state.works_on_map_cluster_total
    },
    works_on_map_list: state => {
      return state.works_on_map_list
    },
    works_on_map_list_total: state => {
      return state.works_on_map_list_total
    },

    sets: state => {
      return state.sets
    },
    setsTotal: state => {
      return state.setsTotal
    },
    setsLoading: state => {
      return state.setsLoading
    },

    artists: state => {
      return state.artists
    },
    artistsTotal: state => {
      return state.artistsTotal
    },
    artistsLoading: state => {
      return state.artistsLoading
    },

		worksTotal: state => {
			return state.worksTotal
		},
		worksLoading: state => {
			return state.worksLoading
		},
    advanced: state => {
			return state.advanced
		},
		filters: state => {
			return state.filters
		},
		is_empty_filters: state => {
      if ( state.filters.annotation!=null ) return false;
      if ( state.filters.liked!=null ) return false;
      if ( state.filters.type!=null ) return false;
      if ( state.filters.saletype!=null ) return false;
      if ( state.filters.audioguides!=null ) return false;
      if ( state.filters.artist!=null ) return false;
      if ( state.filters.color!=null ) return false;
      if ( state.filters.country!=null ) return false;
      if ( state.filters.genre!=null ) return false;
      if ( state.filters.preset!=null ) return false;
      if ( state.filters.year_from!=null ) return false;
      if ( state.filters.year_to!=null ) return false;
      if ( state.filters.place!=null ) return false;
      if ( state.filters.gallery!=null ) return false;
      if ( state.filters.price_min!=null ) return false;
      if ( state.filters.price_max!=null ) return false;
      if ( state.filters.pro!=null ) return false;
      if ( state.filters.picked!=null ) return false;
      if ( state.filters.video!=null ) return false;
      if ( state.filters.copy_of!=null ) return false;
      if ( state.filters.region!=null ) return false;
      if ( state.filters.plregion!=null ) return false;
      if ( state.filters.size!=null ) return false;
      if ( state.filters.style!=null ) return false;
      if ( state.filters.tag!=null ) return false;
      if ( state.filters.work!=null ) return false;
      if ( state.filters.technique!=null ) return false;
      if ( state.filters.best!=null ) return false;

      if ( state.filters.name!=null ) return false;
      if ( state.filters.p!=null && state.filters.p>1 ) return false;

      if ( state.filters.acollection!=null ) return false;
      if ( state.filters.gcollection!=null ) return false;

	    //нет реального фильтра, но фильтрация потенциально возможна
	    if ( state.filters.school!=null ) return false;
	    if ( state.filters.material!=null ) return false;

			return true;
		},

    modificators: state => {
      return state.modificators
    },

		tags: state => {
			return state.tags
		},
		tag: state => {
			return keyword => {
				return state.tags[keyword]
			}
		},
		artist: state => {
			return keyword => {
				return state.tags[keyword]
			}
		},
		langs: state => {
			return state.langs
		},
		userId: state => {
			return state.userId
		},
		user_artist_id: state => {
			return state.user_artist_id
		},
    user_currency: state => {
			return state.user_currency
		},
    is_user_has_pro: state => {
			return state.is_user_has_pro
		},
    is_user_has_payout: state => {
			return state.is_user_has_payout
		},
    is_user_editor: state => {
			return state.is_user_editor
		},

		arttypes: state => {
			return state.arttypes
		},
		saletypes: state => {
			return state.saletypes
		},
		countries: state => {
			return state.countries
		},
    colors: state => {
			return state.colors
		},
    filters_counts: state => {
			return state.filters_counts
		},
    genres: state => {
      return state.genres
    },
    presets: state => {
      return state.presets
    },
    sizes: state => {
      return state.sizes
    },
    styles: state => {
      return state.styles
    },
    techniques: state => {
      return state.techniques
    },
    places: state => {
      return state.places
    },
    galleries: state => {
      return state.galleries
    },
    schools: state => {
      return state.schools
    },
    materials: state => {
      return state.materials
    },
    periods: state => {
      return state.periods
    },
    prices: state => {
      return state.prices
    },

	}
});



//////////////////
// WEBPACK FOOTER
// ./src/store/Works.js
// module id = null
// module chunks = 